export function generateRandomString(length: number) {
  const crypto = window.crypto || (window as any).msCrypto;
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let randomString = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = crypto.getRandomValues(new Uint32Array(1))[0] % charactersLength;
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}
